import React, { Component } from 'react';
import './Features.scss'
import { Banner } from '../../Components'
import WOW from 'wowjs'
import {Helmet} from "react-helmet"
import { Link } from 'react-router-dom'
class About extends Component {

    componentDidMount() {
		new WOW.WOW({
			mobile: false,
		}).init();
        window.scrollTo(0,0)
    }
    
    render() {
        return (
            <div>
				<Helmet>
					<title>Features | GPbook</title>
				</Helmet>	
                <Banner title="Features" subtitle="About the Online System and Benefits" />
                <div className="feature-circle" >
                    <div className="container">
                        <div className="features">
                            <img src={require('./circle.jpg')} alt="GPbook Features" className="wow zoomIn" />

                            <div className="top revert">
                                <div className="wow bounceIn" data-wow-delay="0.7s">
                                    <i className="fa fa-address-card-o"></i>
                                    Up To Date <span>Updated Regularly</span>
                                </div>
                            </div>
                            <div className="top-left revert" >
                                <div className="wow bounceIn" data-wow-delay="0.6s">
                                    <i className="fa fa-users"></i>
                                Comprehensive <span>Specialist Directory</span>
                                </div>
                            </div>
                            <div className="top-right revert">
                                <div className="wow bounceIn" data-wow-delay="0.8s">
                                    <i className="fa fa-map-marker"></i>
                                Geolocation <span>Find specialists close to you</span>
                                </div>
                            </div>
                            <div className="left revert">
                                <div className="wow bounceIn" data-wow-delay="0.5s">
                                    <i className="fa fa-cubes"></i>
                                    Special Interests <span>Listed</span>
                                </div>
                            </div>
                            <div className="right revert">
                                <div className="wow bounceIn" data-wow-delay="0.9s">
                                    <i className="fa fa-filter"></i>
                                    Search Filters <span>Find a female obstetrician<br />that speaks Indonesian</span>
                                </div>
                            </div>
                            <div className="bottom-left revert">
                                <div className="wow bounceIn" data-wow-delay="0.4s">
                                    <i className="fa fa-star"></i>
                                    Personal Favourites <span>Customised List</span>
                                </div>
                            </div>
                            <div className="bottom-right revert">
                                <div className="wow bounceIn" data-wow-delay="1.0s">
                                    <i className="fa fa-phone"></i>
                                Mobiles Listed <span>for Emergencies</span>
                                </div>
							</div>
							<div className="bottom">
                                <div className="wow bounceIn" data-wow-delay="1.0s">
                                    <i className="fa fa-phone"></i>
                              	 	Telehealth <span>Find doctors that<br/>are telehealth ready</span>
                                </div>
                            </div>
						</div>    
						
                    </div>
                </div>
                <div className="feature-page">
                    <div className="container">
						<Link to="/pricing" className="btn secondary lg wow fadeInDown" data-wow-delay="1.1s">Subscribe Now</Link>
                    </div>
                </div>

                <div className="feature-item page text-center">
                    <div className="container">
                        <div className="wow fadeInUp" data-wow-delay="0.2s">
                            <h3>Our powerful search bar helps you search smarter</h3>
                            <p>Our search bar gives you all the tools to quickly search and access the specialists you are after.</p>
                        </div>
                        <img src={require('./searchbar.png')} alt="GPbook Searchbar" className="searchbar wow zoomIn" />
                    </div>    
                </div>

                <div className="feature-item alt page">

                    <div className="container">
                        <div className="row">
                            <div className="col-md-7">
                                <h3>Personalised Favourites</h3>
                                <p>Using Personalised Favourites, you can see keep track of which specialists you trust. A gold star next to a listing indicates that you have favourited a specialist or you can access them in your ‘Favourites List’.</p>
                            </div>
                            <div className="col-md-5">
                                <img src={require('./favourite.jpg')} alt="GPbook Favourite" className="favimage wow fadeInRight"  />
                            </div>
                        </div>
                    </div>  
                    
                </div>

                <div className="feature-item page">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-5">
                                <div className="video-holder wow fadeInLeft">
                                    <video autoPlay loop>
                                        <source src={require('../Home/video.webm')} type="video/webm" />
                                        <source src={require('../Home/video.mp4')} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                            </div>
                            <div className="col-md-7">
                                <h3>Instantaneous Results</h3>
                                <p>Results returned to you instantaneous as you type. It’s lightning fast so you can get on with your day. This is because our system uses the state of the art React Framework, adopted by industry giants like Facebook, Netflix and Seek.</p>
                            </div>
                        </div>
                    </div>  
                </div>

                <div className="feature-item alt page">

                    <div className="container">
                        <div className="row">
                            <div className="col-md-7">
                                <h3>Specialist Information</h3>
                                <p>Each specialist listed in the the Medical & Surgical Specialist Referral Directory by Stephen Hodby can also be found on GPbook. We keep the latest up to date record for each listing. Additional information is compiled for each result that can all be visible on the page, including:</p>
                                <ul>
                                    <li>Personal Details</li>
                                    <li>Contact Information</li>
                                    <li>Qualitications</li>
                                    <li>Spoken Languages</li>
                                    <li>Specialities</li>
                                    <li>Special Interests</li>
                                    <li>WC/ DVA/ MVIT/ Gap/ etc</li>
                                    <li>Primary Practicing Clinic</li>
                                    <li>Secondary Clinic</li>
                                    <li>Public and Private Hospitals</li>
                                    <li>Distance from your current location</li>
                                    <li>What patients a specialist might not be able see</li>
                                </ul>

                                <Link to="/contact" className="btn lg m-t-1">Apply for Listing</Link>
                            </div>
                            <div className="col-md-5">
                            <img src={require('../Update/profile.jpg')} alt="GPbook Profile" className="favimage wow fadeInRight"  />
                            </div>
                        </div>
                    </div>  
                    
                </div>


                <div className="feature-item page">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3">
                             <img src={require('../Home/mssd.png')} alt="GPbook Physical Publication" className="wow fadeInLeft" width="75%"  />
                            </div>
                            <div className="col-md-9">
                                <h3>
                                    Up To Date Contact Information</h3>
                                <p>
                                    The online database will be kept up to date throughout the year, as new information is updated. This ensures that you will always have the latest information whether you are using the physical publication or the online directory. If you are a practice manager or a specialist with a listing, you can update your details on the following page:
                                </p>
                                <Link to="/update" className="btn lg m-t-1">Update your details</Link>
                            </div>
                        </div>
                    </div>  
                </div>

            </div>
        );
    }
}

  
 

export default About;


// WEBPACK FOOTER //
// ./src/Containers/Features/Features.js